import moment from "moment";
import { faChampagneGlasses } from "@fortawesome/free-solid-svg-icons";
import { Content, PaginationTable, ButtonLink } from "@webtypen/react-components";
import { Page } from "../../components/Page";

export const EmployeesShiftsOverview = () => {
    const today = moment().format("YYYY-MM-DD");
    return (
        <Page icon={faChampagneGlasses} title="Deine Job- / Schichten-Übersicht">
            <Content>
                <PaginationTable
                    url="/api/employees-shifts/list"
                    tableAttributes={{ className: "valign-middle" }}
                    columns={[
                        { label: "Datum", attributes: { style: { width: 90 } } },
                        { label: "Beginn", attributes: { style: { width: 90 } } },
                        { label: "Ende", attributes: { style: { width: 90 } } },
                        { label: "Kunde" },
                        { label: "Rolle / Typ" },
                        { label: "Optionen", attributes: { style: { width: 130 }, className: "text-right" } },
                    ]}
                    render={(row, i) => (
                        <tr key={i}>
                            <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                {row.date ? moment(row.date).format("DD.MM.YYYY") : "-"}
                            </td>
                            <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                {row.begin_planned ? row.begin_planned : "-"}
                            </td>
                            <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                {row.end_planned ? row.end_planned : "-"}
                            </td>
                            <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                {row.customer_object && row.customer_object.name ? row.customer_object.name : "-"}
                            </td>
                            <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                {row.type && row.type_object && row.type_object.name ? row.type_object.name : "-"}
                            </td>
                            <td className="text-right">
                                <ButtonLink to={"/employees-shifts/" + row._id + "/details"} sm>
                                    Öffnen
                                </ButtonLink>
                            </td>
                        </tr>
                    )}
                />
            </Content>
        </Page>
    );
};
